import { connect } from 'react-redux';

import FlashMessage from './flash-message';

const mapStateToProps = (state) => ({
  messages: state.flashMessages,
});

export default connect(mapStateToProps)(FlashMessage);
